<template>
	<article class="swiper-slide">
		<section>
			<!-- :href="item.content" :aria-label="`view all ${className}`" -->
			<div class="card-wrapper">
				<router-link
					:to="linkLocation.replace(/\s+/g, '-').toLowerCase()"
					class="card-link"
				>
					<figure>
						<font-awesome-icon :icon="['fas', 'eye']" />
						<span class="view-all-text">View All</span>
					</figure>
				</router-link>
			</div>
		</section>
	</article>
</template>

<script>
export default {
	name: 'ViewAllCard',
	props: {
		linkLocation: String,
	},
};
</script>

<style lang="scss" scoped>
.swiper-slide {
	width: 150px;
}
.card-wrapper {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-decoration: none;
	background-color: transparent;
	-webkit-transition: all 0.15s cubic-bezier(0.4, 0, 1, 1);
	transition: all 0.15s cubic-bezier(0.4, 0, 1, 1);
	border: $b360-border-width-thin solid $border-color-light;
	margin-left: 20px;
	margin-right: 50px;
	width: 150px;
	cursor: pointer;
	&:hover {
		background-color: $border-color-light;
	}
	// TODO : MAKE THIS A VARIABLE?

	a {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-decoration: none;

		svg {
			font-size: 48px;
			color: $brand-blue;
		}

		figure {
			display: flex;
			flex-wrap: wrap;
			flex-direction: column;
		}
	}
}

.card-wrapper {
	position: relative;
	height: 200px;
	border-radius: $b360-border-radius-base;

	video,
	img,
	.card-link {
		width: 100%;
		height: 100%;
		border-radius: $border-radius;
		object-fit: cover;
	}

	.notification {
		@include rem(padding, 5px);
		border-radius: $b360-border-radius-base;
		position: absolute;
		bottom: 11px;
		left: 11px;

		&.new {
			background-color: $b360-color--orange;
			color: $white;
			@include typo--roboto__bold;
			@include rem(font-size, 12px);
			@include rem(line-height, 12px);
		}
	}
}

h2 {
	@include rem(font-size, 17px);
	@include typo--roboto__medium;
	@include rem(line-height, 17px);
	@include rem(margin, 20px 0 10px 0);
	text-transform: capitalize;
}

p {
	@include rem(font-size, 15px);
	@include typo--roboto__regular;
	color: $b360-color--gray__darkest;
	padding: 0 0 10px 0;
}

.learn-more {
	color: $brand-blue;
	text-decoration: none;
	@include typo--roboto__medium;

	&:hover,
	&:focus {
		text-decoration: underline;
	}
}
</style>
